import { Dropdown } from "react-daisyui";
import { Link } from "react-router-dom";
import { IconChevronDown, IconLogout } from "@tabler/icons-react";
import { useAuth } from "src/authentication/hooks/useAuth";
import { PersonAvatar } from "src/people/components/PersonAvatar";
import { classNames } from "src/core/utilities/classNames";
import { useFrameMenu } from "./useFrameMenu";

interface Props {
    /** The collapsed rail has room for the avatar alone */
    compact?: boolean;
}

export const AccountMenu = ({ compact = false }: Props) => {
    const { person, logout } = useAuth();
    const { account } = useFrameMenu();

    if (!person) return null;

    return (
        <Dropdown className={classNames(compact ? "dropdown-top dropdown-right" : "w-full")}>
            <Dropdown.Toggle
                button={false}
                aria-label={compact ? `${person.firstName} ${person.lastName}` : undefined}
                className={classNames(
                    "flex items-center gap-3 rounded-full transition-all hover:bg-base-content/10 active:scale-95",
                    compact ? "p-1.5" : "w-full py-2 pl-2 pr-4"
                )}
            >
                <PersonAvatar person={person} size={40} />

                {!compact && (
                    <>
                        <span className="grow text-left leading-tight">
                            <span className="block font-bold">{person.firstName}</span>

                            <span className="block text-xs text-base-content/70">My details and sign out</span>
                        </span>

                        <IconChevronDown className="opacity-60" />
                    </>
                )}
            </Dropdown.Toggle>

            <Dropdown.Menu className="w-56 z-10 shadow-lg">
                {account.map((link) => (
                    <li key={link.to} role="menuitem">
                        <Link to={link.to}>
                            <link.icon /> {link.label}
                        </Link>
                    </li>
                ))}

                <li role="menuitem">
                    <button type="button" onClick={logout}>
                        <IconLogout /> Sign out
                    </button>
                </li>
            </Dropdown.Menu>
        </Dropdown>
    );
};
